module.exports = __webpack_public_path__ + "6ccb5f9a5d8fa63efc986538cf923f93.jpg";